import React from "react";
import "moment-timezone";
import 'react-slidedown/lib/slidedown.css'
import Tooltip from "@material-ui/core/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";

class CheckParticipacaoModulos extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let {participacao} = this.props;

    if (!participacao) return null;

    return <Tooltip
      title={participacao.registos > 0 ? (participacao.registos_aceites > 0 ? "Registo Aceite" : "Registo Pendente") : "Sem registo"}
      placement={this.props.tooltipPlacement || "top"}
    ><span>{
      participacao.registos > 0 && <FontAwesomeIcon icon={faCheck} color={"#028b06"} style={{marginLeft: "5px"}}/>
    }{
      participacao.registos_aceites > 0 && <FontAwesomeIcon icon={faCheck} color={"#028b06"} style={{marginLeft: "-9px"}}/>
    }</span></Tooltip>;
  }
}

export default CheckParticipacaoModulos;
